import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import './HomePage.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-cards';
import 'swiper/css/pagination';

const { Title, Text } = Typography;

const HomePage: React.FC = () => {
    // 轮播图数据
    const bannerItems = [
        {
            image: "./home/home_banner_1.webp"
        },
        {
            image: "./home/home_banner_2.webp"
        },
        {
            image: "./home/home_banner_3.webp"
        }
    ];


    return (
        <div className="home-page">
            {/* 主要横幅区域 */}
            <div className="top-bg">
                <div className="banner-section">
                    <div className="banner-images">
                        <div className="carousel-wrapper">
                            <Swiper
                                modules={[EffectCards, Autoplay, Pagination]}
                                effect="cards"
                                cardsEffect={{
                                    perSlideOffset: 8,
                                    perSlideRotate: 0
                                }}
                                loop={true}
                                speed={800}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true
                                }}
                                pagination={{
                                    clickable: true
                                }}
                            >
                                {bannerItems.map((item, index) => (
                                    <SwiperSlide key={index} className="banner-item">
                                        <div className="banner-content">
                                            <img src={item.image} className="banner-image" alt={`Banner Image ${index + 1}`} />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                    </div>
                </div>

                {/* 三个核心课程卡片 */}
                <div className="courses-section">
                    <div className="course-card">
                        <img src={"./home/home_func_1.webp"} width={'100%'}/>
                    </div>
                </div>
            </div>

            {/* 学习内容区域 */}
            <div className="learning-content">
                <div className="learning-content-bg">
                    <Title level={1} style={{color: 'white'}}>弱视/斜视训练系统</Title>
                    <Text style={{color: 'white', fontSize: '18px', display: 'block'}}>丰富的训练课程 科学的训练模式</Text>
                    <div style={{
                        maxWidth: '1200px',
                        margin: '0 auto',
                        padding: '0 20px'
                    }}>
                        <img src={"./home/home_func_2.webp"} width={'100%'}/>
                    </div>
                </div>
            </div>

            {/* 动画片训练课程 */}
            <div className="animation-training">
                <div className="animation-training-bg">
                    <Title level={1} style={{color: '#EA8100'}}>动画片训练课程</Title>
                    <Text className="animation-text" style={{marginBottom: '20px'}}>海量动画片内容自由选择</Text>
                    <div style={{
                        maxWidth: '1200px',
                        margin: '0 auto',
                        padding: '0 20px'
                    }}>
                        <img src={"./home/home_func_3.webp"} width={'100%'}/>
                    </div>
                </div>
            </div>

            {/* 专业能力展示 */}
            <div className="professional-ability">
                <div className="professional-ability-bg">
                    <Title level={1} style={{color: 'white'}}>全面的专业能力</Title>
                    <Text className="ability-text">一对一定制适合的训练计划</Text>
                    <div className="ability-showcase">
                        <img src={"./home/home_func_4.webp"} width={'100%'}/>
                    </div>
                </div>
            </div>

            {/* 诊疗流程 */}
            <div className="treatment-process">
                <div className="treatment-process-bg">
                    <Title level={1} style={{color: '#066E75'}}>科学的诊疗流程</Title>
                    <Text style={{color: '#066E75', fontSize: '18px', display: 'block'}}>科学 专业 值得信赖</Text>
                    <div className="process-diagram">
                        <img src={"./home/home_func_5.webp"} width={'100%'}/>
                    </div>
                </div>
            </div>

            {/* 公司实力 */}
            <div className="company-strength">
                <div className="company-strength-bg">
                    <Title level={1} style={{color: '#E43751'}}>公司的实力和资质</Title>
                    <div className="process-diagram">
                        <img src={"./home/home_func_6.webp"} width={'100%'}/>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default HomePage;